import { render, staticRenderFns } from "./BoletimMedicaoAnexos.vue?vue&type=template&id=ac0e4728&"
import script from "./BoletimMedicaoAnexos.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoAnexos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports